module.exports = __webpack_public_path__ + "img/home-video-placeholder.06979d12.jpg";